import { FormRender } from '../../../forms/FormRenderer/types'
import { CustomerModelTypeShopAndAddress } from '../../../specificComponents/Customers/types'
import { getDictionaryStates } from '../../globals/countries'
import { sortCountries } from '../../globals/sortCountries'
import { getDictionaryCountries } from '../../reducers/getters'
import useCountryState from '../useCountry'
import useTwinTranslation from '../useTwinTranslation'

interface CreateCustomerAddressProps {
    createWorkingCenter: boolean
}

const useCreateCustomerB2BWCAndAddress = ({ createWorkingCenter }: CreateCustomerAddressProps) => {
    const { country, setCountry } = useCountryState({ defaultCountry: '' })
    const { t } = useTwinTranslation()
    const workingCenterFields: FormRender<CustomerModelTypeShopAndAddress> = []
    const workingCenterFieldsCSV: FormRender<any> = []
    if (createWorkingCenter) {
        workingCenterFields.push(
            {
                cols: 3,
                title: t('workingCenter', 'Centro de trabajo'),
                elements: [
                    {
                        name: 'nameWorkingCenter',
                        label: t('name', 'Nombre'),
                        component: 'InputWithLabelMargin',
                        type: 'text',
                        required: true
                    },
                    {
                        name: 'responsible',
                        label: t('responsible', 'Responsable'),
                        component: 'InputWithLabelMargin',
                        type: 'text',
                        required: true
                    },
                    {
                        name: 'address',
                        label: t('address', 'Dirección'),
                        component: 'InputWithLabelMargin',
                        type: 'text',
                        required: true
                    },
                    {
                        name: 'additional_address',
                        label: t('additional_address', 'Dirección adicional'),
                        component: 'InputWithLabelMargin',
                        type: 'text',
                    },
                    {
                        name: 'postal_code',
                        label: t('postal_code', 'Código Postal'),
                        component: 'InputWithLabelMargin',
                        type: 'text',
                        required: true
                    },
                    {
                        name: 'city',
                        label: t('city', 'Ciudad'),
                        component: 'InputWithLabelMargin',
                        type: 'text',
                        required: true
                    },
                    {
                        name: 'country',
                        label: t('country', 'País'),
                        component: 'CustomSelectWithSearchBar',
                        items: getDictionaryCountries(),
                        sortFunction: sortCountries,
                        value: '',
                        onChange: (value: string) => setCountry(value),
                        required: true
                    },
                    {
                        name: 'state',
                        label: t('state', 'Provincia'),
                        component: 'CustomSelectWithSearchBar',
                        sortItems: true,
                        items: getDictionaryStates(country),
                        value: '',
                        required: true
                    },
                    {
                        name: 'phone',
                        label: t('phone', 'Teléfono'),
                        component: 'InputWithLabelMargin',
                        type: 'text',
                    },
                    {
                        name: 'mobile',
                        label: t('mobile', 'Móvil'),
                        component: 'InputWithLabelMargin',
                        type: 'text',
                    },
                    {
                        name: 'email',
                        label: t('email', 'Email'),
                        component: 'InputWithLabelMargin',
                        type: 'text',
                    },
                    {
                        name: 'createAddressToo',
                        label: t('createAddressToo', 'También crear dirección'),
                        component: 'CheckboxMargin',
                        defaultChecked: true
                    },
                ]
            }
        )
        workingCenterFieldsCSV.push(
            {
                cols: 2,
                elements: [
                    {
                        name: 'posNameWorkingCenterColumn',
                        label: t('posNameWorkingCenterColumn', 'Posición columna nombre del centro de trabajo'),
                        component: 'InputWithLabelMarginIntegerStateFull',
                        required: true
                    },
                    {
                        name: 'posResponsibleColumn',
                        label: t('posNameResponsibleColumn', 'Posición columna nombre del responsable'),
                        component: 'InputWithLabelMarginIntegerStateFull',
                        required: true
                    },
                ],
            },
            {
                cols: 2,
                title: t('address', 'Dirección'),
                elements: [
                    {
                        name: 'posAddressColumn',
                        label: t('posAddressColumn', 'Posición columna dirección'),
                        component: 'InputWithLabelMarginIntegerStateFull',
                        required: true
                    },
                    {
                        name: 'posAddressAdditionalColumn',
                        label: t('posAddressAdditionalColumn', 'Posición columna dirección adicional'),
                        component: 'InputWithLabelMarginIntegerStateFull',
                    },
                    {
                        name: 'posPostalCodeColumn',
                        label: t('posPostalCodeColumn', 'Posición columna código postal'),
                        component: 'InputWithLabelMarginIntegerStateFull',
                        required: true
                    },
                    {
                        name: 'posCityColumn',
                        label: t('posCityColumn', 'Posición columna ciudad'),
                        component: 'InputWithLabelMarginIntegerStateFull',
                        required: true
                    },
                    {
                        name: 'posCountryColumn',
                        label: t('posCountryColumn', 'Posición columna país'),
                        component: 'InputWithLabelMarginIntegerStateFull',
                        required: true
                    },
                    {
                        name: 'posStateCountryColumn',
                        label: t('posStateCountryColumn', 'Posición columna provincia'),
                        component: 'InputWithLabelMarginIntegerStateFull',
                        required: true
                    },
                    {
                        name: 'createAddressToo',
                        label: t('createAddressToo', 'También crear dirección'),
                        component: 'CheckboxMargin',
                        defaultChecked: true
                    },
                ]
            }
        )
    }
    return { workingCenterFields, workingCenterFieldsCSV }
}


export default useCreateCustomerB2BWCAndAddress